import { FunctionComponent } from 'react';
import { SUEmailSentModal } from 'widgets/auth/signUp/EmailSentModal';

export const SignUpEmailSent: FunctionComponent = () => {
	return <SUEmailSentModal />;
};
